@let isLoading =
  archiveEc.plugins.currentListPlugin.feature.selectors.isLoading.asSignal();
@let archive =
  archiveEc.plugins.currentEntityPlugin.feature.selectors
    .getEditedEntity()
    .asSignal() ??
  archiveEc.plugins.currentEntityPlugin.feature.selectors
    .getEntity()
    .asSignal();

<div class="atn-summit-archive-detail">
  @if (isLoading) {
    <div class="atn-summit-archive-detail__loading">
      <div class="atn-summit-archive-detail__header">
        <div
          class="atn-summit-archive-detail__skeleton atn-summit-archive-detail__skeleton--title"
        ></div>
        <div
          class="atn-summit-archive-detail__skeleton atn-summit-archive-detail__skeleton--date"
        ></div>
      </div>
      <div class="atn-summit-archive-detail__content">
        <div
          class="atn-summit-archive-detail__skeleton atn-summit-archive-detail__skeleton--editor"
        ></div>
      </div>
    </div>
  } @else if (!archive) {
    <atn-ds-empty-state
      description="Select an existing note or create a new one to get started"
      layout="v"
      title="Get Started"
      type="add-default"
    />
  } @else {
    <div class="atn-summit-archive-detail__header">
      <i
        class="atn-icon atn-settings atn-blue atn-summit-archive-detail__config-icon"
        (click)="layoutStore.patchState({ presentConfigurator: true })"
      ></i>
      <div class="atn-summit-archive-detail__title">
        <atn-detail-title-editor
          [value]="archive.name"
          (valueChange)="
            archiveEc.currentValueChangeHandler(
              'Summit.Archive.Detail',
              'name',
              $event ?? ''
            )
          "
        />
      </div>
      <div class="atn-summit-archive-detail__meta">
        <span class="atn-summit-archive-detail__date">{{
          archive.date | date: 'MMM d, y - HH:mm'
        }}</span>
      </div>
    </div>
    <atn-detail-ai-banner />
    <div class="atn-summit-archive-detail__content">
      <atn-ds-rich-text-editor
        [value]="archive.description"
        (valueChange)="
          archiveEc.currentValueChangeHandler(
            'Summit.Archive.Detail',
            'description',
            $event
          )
        "
      />
    </div>
  }
</div>
